export const rdfProspIntroText = [
  'Here are the T. Rowe Price mutual funds that may be recommended to you and their prospectuses, which detail their objectives, performance, risks, and fees.'
];
